import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import nl from "./locales/nl.json";
import de from "./locales/de.json";
import en from "./locales/en.json";

// NL is source-of-truth; DE/EN fall back to NL for missing keys.
i18n.use(initReactI18next).init({
  resources: {
    nl: { translation: nl },
    de: { translation: de },
    en: { translation: en },
  },
  lng: "nl",
  fallbackLng: "nl",
  interpolation: { escapeValue: false },
  returnEmptyString: false,
  react: { useSuspense: false },
});

export default i18n;
